/**
 * Created by hernanherreros on 2019-05-03
 */

import * as React from 'react'
import ReservationContext, { ReservationContextInterface } from './reservationContext'
import withWizardProps, { WizardProps } from '../../wrappers/withWizardParams'
import { flowRight } from 'lodash'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { getReservation } from '../../requests/inscription'
import LoaderWrapper from '../../components/Utils/LoaderWrapper'
import NotFoundError from './Screens/NotFoundError'
import { TIMER_MINUTES } from '../../config/index.config'
import TimeOut from './Screens/TimeOut'
import withCongress, { ComponentProps } from '../Congress/withCongress'
import LogRocket from 'logrocket'

interface Props extends WizardProps, RouteComponentProps, ComponentProps {
  useTimer: boolean;
}

class ReservationProvider extends React.Component<Props, ReservationContextInterface> {
  constructor (props: Props) {
    super(props)

    this.state = {
      data: null,
      isLoading: true,
      timeOut: false,
      error: '',
    }
  }

  static defaultProps = {
    useTimer: true,
  }

  componentWillMount () {
    this.loadData()
  }

  loadData = () => {
    const { wizard, useTimer } = this.props

    this.setState({ isLoading: true })

    getReservation({ id: wizard.token })
      .then((resp: any) => {
        this.setState({ data: resp.Data })
        useTimer && this.checkTimer()
        this.identifyInscriptionLogRocket(resp.Data)
      })
      .catch((resp: any) => {
        this.setState({ error: resp.message })
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  identifyInscriptionLogRocket = (inscription: any) => {
    if (process.env.NODE_ENV !== 'development') {
      LogRocket.identify(inscription.ID || inscription.UUID, {
        name: `${inscription.FirstNames} ${inscription.LastNames}`,
        email: inscription.Email,
      })
    }
  }

  handleTimeReset = () => {
    const { wizard } = this.props
    const date = new Date().toISOString()

    localStorage.setItem('timer_' + wizard.token, date)
    this.setState({ timeOut: false })
  }

  checkTimer = () => {
    const { wizard } = this.props

    const startTime = localStorage.getItem('timer_' + wizard.token)

    console.log(startTime)

    if (startTime) {
      const date = new Date(startTime)
      const now = new Date()
      const diff = TIMER_MINUTES - (now.getTime() - date.getTime())

      this.setState({ timeOut: diff < 1000 })
    }
  }

  render() {
    const { isLoading, error } = this.state

    if (error) {
      return <NotFoundError message={error}/>
    }

    return (
      <ReservationContext.Provider value={this.state}>
        <LoaderWrapper isLoading={isLoading} over={false} size="large">
          {this.renderContent()}
        </LoaderWrapper>
      </ReservationContext.Provider>
    )
  }

  renderContent () {
    const { timeOut, data } = this.state
    const { children, congress } = this.props

    if (data && !data.IsConfirmed && timeOut) {
      return <TimeOut onReset={this.handleTimeReset} returnPath={'/' + congress.Slug}/>
    } else {
      return children
    }
  }
}



export default flowRight([withRouter, withCongress, withWizardProps])(ReservationProvider)
